import React from "react";
import Default from "./variants/Default";
import type { TooltipProps } from "./types";
import { ClickableTooltip } from "./variants/ClickableTooltip";

export default function Tooltip({ type = "default", ...props }: TooltipProps) {
  return type === "default" ? (
    <Default {...props} />
  ) : (
    <ClickableTooltip {...props} />
  );
}
